import UAParser from 'ua-parser-js';
import semver from 'semver';
/**
 * @param  Array selectedBrowsers List of browsers to look for, eg ['safari']
 * @param  Array selectedVersions Range comparison, eg ['<12'] | ['>=10']
 * @returns Array
 */
const useBrowserMatchVersion = (selectedBrowsers, selectedVersions) => {
  const parser = new UAParser();
  const { browser } = parser.getResult();
  const { name: browserName, version: browserVersion } = browser;
  const ruleIndex = selectedBrowsers.findIndex(
    b => b.toLowerCase() === browserName.toLowerCase(),
  );
  if (ruleIndex > -1) {
    const rule = selectedVersions[ruleIndex];
    if (rule === '*' || semver.satisfies(browserVersion, rule)) return [true];
  }
  return [false];
};

export default useBrowserMatchVersion;
